<template>
	<div v-if="showPage">
		<div class="childrenWrapper">
			<div class="info-list">
				<span class="fl info-desc">选择孩子</span>
				<span class="icon fr icon-you">&#xe636;</span>
				<p class="info-input fr trigger1"></p>
			</div>
			<div v-show="is_physiology">
				<div class="info-list">
					<span class="fl info-desc">孩子身高</span>
					<span class="fr" style="color:rgba(153, 153, 153, 1)">cm</span>
					<input type="text" class="info-input fr height" />
				</div>
				<div class="info-list">
					<span class="fl info-desc">孩子体重</span>
					<span class="fr" style="color:rgba(153, 153, 153, 1)">kg</span>
					<input type="text" class="info-input fr weight"/>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;">
			<div class="save-children" @click="addChild()">新增儿童</div>
			<div class="save-children" @click="startQuestion()">开始测评</div>
		</div>

		<div class="model-box" v-if="modelType=='child'">
			<div class="relative">
				<p class="absolute icon icon-chahao" @click="hideModel()">&#xe603;</p>
				<img src="../assets/model.png" style="margin-bottom: 0.6rem;" />
				<p class="model-text">为确保测评准确</p>
				<p class="model-text">请先添加宝宝信息</p>
				<div class="model-btn-box" style="display:flex;justify-content:center;margin-top:1rem;">
					<p class="model-btn agin" style="width: 2.74rem;" @click="touserinfo()">添加宝宝信息</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showPage:false,
				modelType:'',
				children:'',
				scalar_id:'',
				user_id:'',
				insituation:'',
				is_physiology:false,
				base_info:'',
				choose1:'',
				choose2:'',
				choose3:'',
				jingji:'',
				xueli:'',
				hukou:'',
				assess:''
			}
		},
		created: function() {
			if(this.$route.params.id==undefined){
				history.go(-1); 
			}else{
				this.showPage = true;
			}
			this.scalar_id = this.$route.params.id;
			this.user_id = JSON.parse(localStorage.getItem('user')).openid;
			this.insituation = sessionStorage.getItem('insituation');
		},
		methods: {
			selectChildren:function(){
				var that = this;
				var api = 'institutions/'+this.insituation+'/users/'+this.user_id+'/roles/0/children/'+this.children.openid+'/scalars/'+this.scalar_id+'/assesses';
				http.get(api).then(function(res){
					if(res.data.is_physiology){
						that.is_physiology = false;
					}else{
						that.is_physiology = true;
					}
				}).catch(function(res){
					console.log(res);
				})
			},
			selectParent:function(){
				var that = this;
				var api = 'institutions/'+this.insituation+'/users/'+this.user_id+'/roles/'+this.role+'/children/'+this.children.openid+'/scalars/'+this.scalar_id+'/assesses';
				http.get(api).then(function(res){
					if(res.data.base_info!=null && res.data.base_info.length!=0){
						that.is_physiology = false;
						that.base_info = res.data.base_info;
						that.assess = res.data.assess;
					}else{
						that.is_physiology = true;
						that.base_info = '';
						that.assess = '';
					}
				}).catch(function(res){
					console.log(res);
				})
			},
			addChild:function(){
				this.$router.push({name:'addchild'})
			},
			startQuestion:function(){
				var that = this;
				var url = 'institutions/'+this.insituation+'/assesses'
				if(this.children==''){
					alert1('请选择测评孩子');
					return;
				}
				if(this.is_physiology){
					if($('.height').val()==''){
						alert1('请填写孩子当前身高');
						return;
					}
					if($('.weight').val()==''){
						alert1('请填写孩子当前体重');
						return;
					}
					http.post('institutions/'+this.insituation+'/children/physiologists?user_id='+this.user_id+'&openid='+this.children.openid+'&height='+$('.height').val()+'&weight='+$('.weight').val()).then(function(){
						http.post(url+'?user_id='+that.user_id+'&openid='+that.children.openid+'&scalar_id='+that.scalar_id+'&role='+that.role).then(function(res){
							that.$router.push({name:'question',params:{number:res.data.data.number,openid:that.children.openid,isdiaoyan:1}})
						}).catch(function(res){
							console.log(res);
							alert1('孩子的年龄不适合这个测评，可以尝试换一个其它量表或者新添加一个孩子来进行测评');
						})
					}).catch(function(res){
						console.log(res);
					})
				}else{
					http.post(url+'?user_id='+that.user_id+'&openid='+that.children.openid+'&scalar_id='+that.scalar_id+'&role='+that.role).then(function(res){
						console.log(res);
						that.$router.push({name:'question',params:{number:res.data.data.number,openid:that.children.openid,isdiaoyan:1}})
					}).catch(function(res){
						console.log(res);
						alert1('孩子的年龄不适合这个测评，可以尝试换一个其它量表或者新添加一个孩子来进行测评');
					})
				}
				
			},
			trigger1:function(){
				var that = this;
				var children = JSON.parse(localStorage.getItem('user')).children.data;
				var arr = [];
				for(var i=0;i<children.length;i++){
					arr.push(children[i].name)
				}
				var mobileSelect1 = new MobileSelect({
					    trigger: '.trigger1', 
					    title: '选择孩子',  
					    wheels: [
					                {data: arr}
					            ],
					    position:0, //初始化定位 打开时默认选中的哪个 如果不填默认为0
					    transitionEnd:function(indexArr, data){
						    
					    },
					    callback:function(indexArr, data){
						    that.children = children[indexArr[0]];
						    console.log(that.children);
						    that.selectChildren();
					    }
					});
			}
		},
		mounted:function(){
			if($('.trigger1').length!=0){
				this.trigger1();
			}
			$('#demo_date').mobiscroll().date({
	            theme: "ios",
	            mode: "scroller",
	            display: "bottom",
	            dateFormat:"yyyy-mm-dd",
	            lang: "zh"
	        });
		},
		components: {},
	}
</script>

<style scoped>
	.model {
		position: fixed;
		height: 100vh;
		width: 100%;
		background: RGBA(0, 0, 0, 0.1);
		top: 0;
		left: 0;
	}
	
	.model-box {
		margin-top: 2.00rem;
		margin-left: 0.96rem;
		width: 5.60rem;
		height: 6.00rem;
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
	}
	
	.model-box img {
		width: 100%;
		height: 1.20rem;
		margin-bottom: 0.20rem;
	}
	
	.model-text {
		padding-top: 0.20rem;
		line-height: 0.60rem;
		color: RGBA(67, 67, 67, 0.8);
		text-align: center;
		padding-left: 0.26rem;
		padding-right: 0.26rem;
		font-size: 0.38rem;
	}
	
	.model-btn-box {
		margin-top: 0.46rem;
		padding-left: 0.40rem;
		padding-right: 0.40rem;
		display: flex;
		justify-content: space-between;
	}
	
	.model-btn {
		line-height: 0.60rem;
		text-align: center;
		font-size: 0.28rem;
		color: #fff;
		border-radius: 0.06rem;
		width: 1.78rem;
	}
	
	.agin {
		background: #F5859D;
	}
	
	.repeat {
		background: #FFC071;
	}
	
	.icon-chahao {
		right: 0.12rem;
		top: 0.12rem;
		font-size: 0.36rem;
		color: #fff;
	}
	
	.cover-box {
		width: 100%;
		height: 4.20rem;
	}
	
	.cover-img {
		width: 100%;
		height: 100%;
	}
	
	.test-operate-box {
		border-top: 1px solid #ccc;
	}
	
	.border {
		position: absolute;
		height: 0.24rem;
		width: 0.08rem;
		background: #F4869D;
		left: -0.16rem;
		top: 0.24rem;
	}
	.userWrapper {
		padding-bottom: 1.5rem;
	}
	
	.white {
		height: 1rem;
		padding: 0.2rem;
		line-height: 0.4rem;
		/*border-bottom: 1px solid #EEEEEE;*/
		/*text-align: center;*/
		color: #e34e42;
		font-size: 0.24rem;
	}
	
	.info-list {
		height: 0.80rem;
		border-bottom: 1px solid #EEEEEE;
		line-height: 0.80rem;
		padding-right: 0.20rem;
		font-size: 0.24rem;
		padding-left: 0.20rem;
	}
	
	.info-desc {
		color: RGBA(102, 102, 102, 0.8);
	}
	
	.icon-you {
		color: RGBA(153, 153, 153, 0.8);
	}
	
	.info-input {
		width: 3rem;
		color: RGBA(51, 51, 51, 0.8);
		height: 0.80rem;
		text-align: right;
		background: #fff;
	}
	
	.save-children {
		width: 2.40rem;
		height: 0.60rem;
		line-height: 0.60rem;
		background: #26a2ff;
		color: #fff;
		text-align: center;
		font-size: 0.24rem;
		border-radius: 0.50rem;
		margin: 0.30rem auto;
	}
</style>


// WEBPACK FOOTER //
// src/pages/selectinfomation.vue